<ng-container formGroupName="greenManureSettings">
  <div class="flex__child--auto">
    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'greenManure' | translate }}
      </mat-label>
      <input
        type="text"
        [placeholder]="'greenManure' | translate"
        matInput
        [matAutocomplete]="cropAutocomplete"
        #newCropInput
        data-test="green-manure-settings-crop-id"
        formControlName="cropId"
        (blur)="checkCrop()"
      />
      <mat-autocomplete
        #cropAutocomplete="matAutocomplete"
        (optionSelected)="selectCrop($event.option.value)"
        [displayWith]="displayCrop()"
      >
        @for (crop of filteredCrops$ | async; track crop) {
          <mat-option [value]="crop.id" data-test="green-manure-settings-crop-option">
            {{ crop.agrifirmCrop.name }}
          </mat-option>
        }
      </mat-autocomplete>
    </mat-form-field>
  </div>

  <div class="flex__child--auto">
    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'seasonGreenManureIncorporated' | translate }}
      </mat-label>
      <mat-select
        formControlName="seasonGreenManureIncorporated"
        [placeholder]="'seasonGreenManureIncorporated' | translate"
        data-test="green-manure-settings-season-green-manure-incorporated"
      >
        @for (season of seasonKeys; track season) {
          <mat-option [value]="season">{{ season.toLowerCase() | translate }}</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex__child--auto">
    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'successRate' | translate }}
      </mat-label>
      <mat-select
        formControlName="successRate"
        [placeholder]="'successRate' | translate"
        data-test="green-manure-settings-succes-rate"
      >
        @for (successRate of successRates; track successRate) {
          <mat-option [value]="successRate">{{ successRate }} %</mat-option>
        }
      </mat-select>
    </mat-form-field>
  </div>

  <div class="flex__child--auto">
    <div class="mat-slide-group-wrapper">
      <div class="mat-slide-group">
        <mat-slide-toggle
          color="primary"
          formControlName="isNitrogenDeliveryAmountSetManually"
          data-test="green-manure-settings-is-nitrogen-delivery-manually"
          >{{ 'nitrogenDeliveryAmountSetManually' | translate }}</mat-slide-toggle
        >
      </div>
    </div>
    <mat-form-field class="full-width-field">
      <mat-label>
        {{ 'nitrogenDeliveryAmount' | translate }}
      </mat-label>
      <input
        matInput
        agrNumber
        maxlength="7"
        [placeholder]="'nitrogenDeliveryAmount' | translate"
        formControlName="nitrogenDeliveryAmount"
        data-test="green-manure-settings-nitrogen-delivery-amount"
        [step]="1"
        autocomplete="off"
      />
    </mat-form-field>
  </div>
</ng-container>
